import React, { useEffect, useState } from "react";
import FormComponent from "../../../../../components/gernerateForm/FormComponent";
import generateForm11 from "../data/form11.data";

type Props = {
  onSubmit: (value: any) => void;
  isValidateForm: boolean;
  data: any;
  setData: (value: any) => void;
  mainInputValue: any;
  isValudateFile: boolean;
  isCanEdit?: boolean | true;
};
const Form11: React.FC<Props> = (props: Props) => {
  const {
    onSubmit,
    isValidateForm,
    data,
    setData,
    mainInputValue,
    isValudateFile,
    isCanEdit,
  } = props;

  const [inputValueFormLeave11, setInputValueFormLeave11] = useState({
    information: {
      leave_request_cancel: "",
      leave_request_cancel_name: "",
      reason_cancel: "",
    },
  });

  useEffect(() => {
    const information = mainInputValue.information;
    const condition = inputValueFormLeave11.information;

    setData({
      main: information,
      condition: condition,
    });
  }, [inputValueFormLeave11]);

  useEffect(() => {
    if (data?.condition) {
      setInputValueFormLeave11({
        information: data.condition,
      });
    }
  }, []);

  return (
    <FormComponent
      formGenerate={generateForm11}
      inputValue={inputValueFormLeave11}
      setInputValue={setInputValueFormLeave11}
      handleCheckValid={isValidateForm}
      isCanEdit={isCanEdit ?? true}
      permission={"admin"}
    />
  );
};

export default Form11;
